import { AlarmHistoryStatusFilter } from 'sigma-mappings';

const alarmsStatusLookup = vm => ([
  {
    id: AlarmHistoryStatusFilter.ACTED_NOT_RECOGNIZED,
    name: vm.$t('reports.alarms-and-warnings.status-types.acted-not-recognized'),
  },
  {
    id: AlarmHistoryStatusFilter.ACTED_RECOGNIZED,
    name: vm.$t('reports.alarms-and-warnings.status-types.acted-recognized'),
  },
  {
    id: AlarmHistoryStatusFilter.NOT_ACTED_NOT_RECOGNIZED,
    name: vm.$t('reports.alarms-and-warnings.status-types.not-acted-not-recognized'),
  },
  {
    id: AlarmHistoryStatusFilter.NOT_ACTED_RECOGNIZED,
    name: vm.$t('reports.alarms-and-warnings.status-types.not-acted-recognized'),
  },
]);

export default alarmsStatusLookup;
